export default "__VITE_ASSET__DcKkcwHU__"